import { Fusion } from '../../../components/admin/fusion-process/fusion-process-types';
import api from '../../../global/api';
import { prune } from '../../../utils/object/prune';

export async function editFusionApi(id: string, data: Fusion) {
  const response = await api.put<{ id: string }>(
    '/fusion',
    prune({
      ...data,
      batches: data.batches?.map((batch) => ({ ...batch, fusionId: id })),
      id,
    }),
  );
  return response.data;
}
